import React from 'react';
import Form from 'antd/lib/form';
import Input from 'antd/lib/input';
import 'antd/lib/input/style/index.css';
var formStyles = require('src/imports/styles/extend.form.scss');
var InputIdentifier = function (props) { return (React.createElement(Form.Item, { label: React.createElement("span", { className: formStyles.optional }, "Additional identifier"), extra: 'Athlete\'s proof of identity/registration (i.e. gym membership ID, registration receipt number, etc). Avoid using sensitive personal data as identifier!!', colon: false }, props.form.getFieldDecorator('identifier', {
    initialValue: props.initialValue || '',
    rules: [{
            max: 255,
            message: 'Identifier is too long',
        }, {
            type: 'string',
        }],
})(React.createElement(Input, { size: 'large', autoComplete: 'off', disabled: props.isDisabled })))); };
export default InputIdentifier;



//////////////////
// WEBPACK FOOTER
// ./src/pages/WorkspaceEvent/FormAthletePage/FormAthlete/InputIdentifier.tsx
// module id = 1206
// module chunks = 0